global = this

do (req = require) ->

  global.require =

    callback: ->
      # moduleNameが*.jsであってもpathsを参照するように
      require.jsExtRegExp = /^\/|:|\?/
#      require.jsExtRegexp = /^\/|:|\?|(?<!^popper)\.js$/ # 否定的後読みが出来ないので↑で代替

      req?.callback?()

      requirejs.config(
        waitSeconds: 0
      )

      assetsUrl = jsRoutes.controllers.Assets.versioned("").url
      assetsExamplesUrl = jsRoutes.controllers.examples?.Assets.versioned("").url
      webJarsUrl = (webJarId) ->
        jsRoutes.controllers.WebJarAssets.at("#{webJarId}/#{webjars.versions[webJarId]}/").url

      baseUrl = webJarsUrl("popper.js");
      requirejs.config(
        "paths":
          "popper.js": baseUrl + "dist/umd/popper"
      )

      baseUrl = webJarsUrl("bootstrap");
      requirejs.config(
        "paths":
          "bootstrap": baseUrl + "dist/js/bootstrap"
        "shim":
          "bootstrap": [
            "jquery"
            "popper.js"
          ]
      )

      baseUrl = webJarsUrl("knockout-mapping");
      requirejs.config(
        "paths":
          "knockout-mapping": baseUrl + "knockout.mapping"
      )

      baseUrl = webJarsUrl("interactjs");
      requirejs.config(
        "paths":
          "interactjs": baseUrl + "interactjs/dist/interact"
      )

      baseUrl = webJarsUrl("twinkle-ui") + "lib/SlickGrid/";
      requirejs.config(
        "paths":
          "slick.core": baseUrl + "slick.core"
          "slick.dataview": baseUrl + "slick.dataview"
          "slick.editors": baseUrl + "slick.editors"
          "slick.formatters": baseUrl + "slick.formatters"
          "slick.grid": baseUrl + "slick.grid"
          "slick.groupitemmetadataprovider": baseUrl + "slick.groupitemmetadataprovider"
          "slick.remotemodel": baseUrl + "slick.remotemodel"
          "jquery.event.drag": baseUrl + "lib/jquery.event.drag-2.3.0"
          "jquery.event.drop": baseUrl + "lib/jquery.event.drop-2.3.0"
          "jquery-ui": baseUrl + "lib/jquery-ui-1.11.3"
          "slick.rowselectionmodel": baseUrl + "plugins/slick.rowselectionmodel"
          "slick.checkboxselectcolumn": baseUrl + "plugins/slick.checkboxselectcolumn"
        "shim":
          "slick.grid": [
            "slick.core"
            "slick.dataview"
            "slick.editors"
            "slick.formatters"
            "slick.rowselectionmodel"
            "jquery.event.drag"
            "jquery.event.drop"
          ]
          "slick.core": [
            "jquery"
          ]
          "slick.dataview": [
            "slick.core"
          ]
          "slick.editors": [
            "slick.core"
            "jquery-ui"
          ]
          "slick.formatters": [
            "slick.core"
          ]
          "slick.groupitemmetadataprovider": [
            "slick.core"
          ]
          "slick.rowselectionmodel": [
            "slick.core"
          ]
          "slick.checkboxselectcolumn": [
            "slick.core"
          ]
          "jquery-ui": [
            "jquery"
          ]
          "jquery.event.drag": [
            "jquery"
          ]
          "jquery.event.drop": [
            "jquery"
          ]
      )

      baseUrl = webJarsUrl("twinkle-ui") + "lib/";
      requirejs.config(
        "paths":
          "jquery.selector.focusable": baseUrl + "jquery.selector.focusable"
        "shim":
          "jquery.selector.focusable": ["jquery"]
      )

      baseUrl = webJarsUrl("twinkle-ui") + "lib/";
      requirejs.config(
        "paths":
          "jquery.numeric": baseUrl + "jquery.numeric"
        "shim":
          "jquery.numeric": ["jquery"]
      )

      baseUrl = webJarsUrl("twinkle-ui") + "js/";
      requirejs.config(
        "paths":
          "twinkle": baseUrl + "twinkle"
          "twinkle.core": baseUrl + "twinkle.core"
          "twinkle.utils": baseUrl + "twinkle.utils"
          "twinkle.forms": baseUrl + "twinkle.forms"
          "twinkle.controls": baseUrl + "twinkle.controls"
          "twinkle.progress": baseUrl + "twinkle.progress"
          "twinkle.modals": baseUrl + "twinkle.modals"
          "twinkle.dropdowns": baseUrl + "twinkle.dropdowns"
          "twinkle.datetimepicker": baseUrl + "twinkle.datetimepicker"
          "twinkle.ajax": baseUrl + "twinkle.ajax"
          "twinkle.storage": baseUrl + "twinkle.storage"
          "twinkle.navbar": baseUrl + "twinkle.navbar"
          "twinkle.gridOrig": baseUrl + "twinkle.grid"
          "twinkle.grid": assetsUrl + "javascripts/" + "grid_ex"
          "twinkle.grid.formatters": baseUrl + "twinkle.grid.formatters"
          "twinkle.grid.editors": baseUrl + "twinkle.grid.editors"
          "twinkle.grid.plugins": baseUrl + "twinkle.grid.plugins"
          "twinkle.grid.plugins.rowselectionmodel": baseUrl + "twinkle.grid.plugins.rowselectionmodel"
          "twinkle.ko.bindingHandlers": baseUrl + "twinkle.ko.bindingHandlers"
        "shim":
          "twinkle.modals": ["interactjs"]
      )

      # MyApp
      baseUrl = assetsUrl + "javascripts/";
      requirejs.config(
        "paths":
          "app": baseUrl + "app"
          "app.grid.radio": baseUrl + "app.grid.radio"
          "sidebar": baseUrl + "sidebar"
          "server-sent-manager": baseUrl + "server-sent-manager"
      )

      # Common Modals
      baseUrl = assetsUrl + "javascripts/";
      requirejs.config(
        "paths":
          "modals.changePassword": baseUrl + "modals/changePassword"
      )

      # Examples
      baseUrl = assetsExamplesUrl + "javascripts/";
      requirejs.config(
        "paths":
          "modals.browseExample": baseUrl + "modals/browseExample"
      )

      return
